export const config = {
    bucketName: "clikgett",
    dirName: "mtouchdemoapis",
    region: "ap-south-1",
    accessKeyId: process.env.REACT_APP_ACCESSKEY,
    secretAccessKey: process.env.REACT_APP_SECRETKEY,
};
